/* Linear transformation function.
 * Transform `value` from `original` interval linearly into `target` interval.
 */
export const linearTransform = (original, target, value) => {
  if (original.from === original.to) { // original collapsed, target to middle
    return (target.from + target.to) / 2
  }
  return (value - original.from) * (target.to - target.from) / (original.to - original.from) + target.from
}

export const timeToX = ({ timeFrom, timeTo, width, time }) =>
  linearTransform({ from: timeFrom, to: timeTo }, { from: 0, to: width }, time)

export const xToTime = ({ timeFrom, timeTo, width, x }) =>
  linearTransform({ from: 0, to: width }, { from: timeFrom, to: timeTo }, x)

export const zoom = ({ timeFrom, timeTo, time, direction }) => {
  const factor = (direction === 'in') ? 0.5 : 2
  const newTimeFrom = time - factor * (time - timeFrom)
  const newTimeTo = time + factor * (timeTo - time)
  if (newTimeTo - newTimeFrom >= 1) {
    return { timeFrom: newTimeFrom, timeTo: newTimeTo }
  }
}
